"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderDots = exports.SliderDot = exports.SliderControls = exports.SliderButtonIcon = exports.SliderButton = exports.SlideContent = exports.SlideContainer = exports.ReadMore = exports.Photo = exports.NoteWrapper = exports.NoteTextContainer = exports.NoteText = exports.NotesPopup = exports.NoteInfoContainer = exports.NoteDate = exports.NoteContainer = exports.NoteButtonIcon = exports.NoteButton = exports.DataContainer = void 0;
const reactjs_popup_1 = __importDefault(require("reactjs-popup"));
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../../assets/styles/colors");
const media_1 = require("../../../../../utils/media");
const Typography_1 = require("../../../../atoms/Typography");
const NoteWrapper = styled_components_1.default.div `
  position: relative;
  width: fit-content;
`;
exports.NoteWrapper = NoteWrapper;
const NoteButton = styled_components_1.default.button `
  position: absolute;
  background-color: ${(props) => (props.$active ? colors_1.theme : colors_1.white)};
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 3;
`;
exports.NoteButton = NoteButton;
const NoteButtonIcon = styled_components_1.default.img `
  width: 2rem;
  height: 2rem;
  filter: ${(props) => props.$active
    ? "brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(157deg) brightness(101%) contrast(104%)"
    : "none"};
`;
exports.NoteButtonIcon = NoteButtonIcon;
const NotesPopup = (0, styled_components_1.default)(reactjs_popup_1.default) `
  &-content {
    padding: 0;
    border: none;
    background: transparent;
    width: auto;
    margin: 0;
  }
`;
exports.NotesPopup = NotesPopup;
const NoteContainer = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-direction: column;
  background: ${colors_1.white};
  border-radius: 1rem;
  padding: 1.8rem 0.8rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 4;
  width: min-content;

  @media ${media_1.media.desktop} {
    max-width: 60vw;
    width: max-content;
  }
`;
exports.NoteContainer = NoteContainer;
const SlideContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
exports.SlideContainer = SlideContainer;
const SlideContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  margin: 0 1.4rem;
  flex: 1;

  @media ${media_1.media.desktop} {
    flex-direction: row;
    align-items: flex-start;
  }
`;
exports.SlideContent = SlideContent;
const DataContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  max-width: 40rem;
`;
exports.DataContainer = DataContainer;
const NoteInfoContainer = styled_components_1.default.div `
  display: flex;
  gap: 4px;
`;
exports.NoteInfoContainer = NoteInfoContainer;
const Photo = styled_components_1.default.img `
  width: 9rem;
  height: 9rem;
  border-radius: 4px;
  margin-top: 1.4rem;

  @media ${media_1.media.desktop} {
    margin-right: 1.8rem;
    margin-top: 0;
  }
`;
exports.Photo = Photo;
const SliderControls = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8rem;
  padding: 0 0.8rem;
`;
exports.SliderControls = SliderControls;
const SliderButton = styled_components_1.default.button `
  background: ${colors_1.gray100};
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  min-width: 3.2rem;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;
exports.SliderButton = SliderButton;
const SliderButtonIcon = styled_components_1.default.img `
  width: 1.6rem;
  height: 1.6rem;
  transform: ${(props) => (props.$left ? "rotate(180deg)" : "none")};
`;
exports.SliderButtonIcon = SliderButtonIcon;
const SliderDots = styled_components_1.default.div `
  display: flex;
  gap: 0.8rem;
  align-items: center;
  justify-content: center;
  flex: 1;
`;
exports.SliderDots = SliderDots;
const SliderDot = styled_components_1.default.button `
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  border: none;
  background-color: ${(props) => (props.$active ? colors_1.grey : "#D9D9D9")};
  cursor: pointer;
  padding: 0;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors_1.grey};
  }
`;
exports.SliderDot = SliderDot;
const ReadMore = styled_components_1.default.span `
  display: block;
  color: ${colors_1.gray400};
  cursor: pointer;
  font-weight: 700;
  text-decoration: underline;
  margin-top: 0.4rem;
`;
exports.ReadMore = ReadMore;
const NoteTextContainer = styled_components_1.default.div `
  max-height: 10rem;
  max-width: 30rem;
  overflow-y: ${(props) => (props.$isScrollable ? "auto" : "hidden")};

  @media ${media_1.media.desktop} {
    min-height: 5.1rem;
    max-height: 25rem;
    max-width: 30rem;
    overflow-y: auto;
  }
`;
exports.NoteTextContainer = NoteTextContainer;
const NoteText = (0, styled_components_1.default)(Typography_1.H4) `
  margin-left: 0.8rem;
`;
exports.NoteText = NoteText;
const NoteDate = (0, styled_components_1.default)(NoteText) `
  white-space: nowrap;
`;
exports.NoteDate = NoteDate;
